import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

import {computed, inject} from "vue";
import Icon from '../Icon/Icon.vue';
import {IconName} from "../Icon/icons";

interface Props {
  icon?: IconName;
  nested?: boolean;
  disabled?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TextInputOutline',
  props: {
    icon: {},
    nested: { type: Boolean },
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;
const hasError = inject('fieldHasError', computed(() => false));
const disabled = inject('fieldDisabled', computed(() => props.disabled));

const inputClass = computed<string>(() => {
  if (disabled.value) {
    return 'text-neutral2-400 bg-neutral2-025 border border-tile-border';
  }
  if (props.nested) {
    if (hasError.value) {
      throw new Error('Nested inputs do not have errors.');
    }
    return 'bg-tile-nested';
  }
  if (hasError.value) {
    return 'border border-red-500';
  }
  return 'border border-neutral2-300';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rounded-lg p-2 flex", inputClass.value])
  }, [
    (props.icon)
      ? (_openBlock(), _createBlock(Icon, {
          key: 0,
          name: props.icon,
          class: _normalizeClass(['mr-2', {'text-red-500': _unref(hasError)}])
        }, null, 8 /* PROPS */, ["name", "class"]))
      : _createCommentVNode("v-if", true),
    _renderSlot(_ctx.$slots, "default")
  ], 2 /* CLASS */))
}
}

})